import React from 'react';
import useModificationAlert, { ModificationAlertContent } from './use-modification-alert';
import { SweetAlertResult } from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { SweetAlertHookApi, OpenAlertOptions } from 'types';

const useClassroomArchiveAlert = (): SweetAlertHookApi => {
  const { t } = useTranslation('ArchiveClassroomsAlert');
  const Alert = useModificationAlert();

  const open = async ({
    textItems = [],
    onCancel,
    onSubmit,
    html,
    ...rest
  }: OpenAlertOptions = {}): Promise<SweetAlertResult | void> => {
    const title = t('title', { count: textItems.length });
    const confirmButtonText = t('confirm', { count: textItems.length });

    const result: SweetAlertResult | void = await Alert.open({
      html: html ?? <ModificationAlertContent textItems={textItems} />,
      title,
      confirmButtonText,
      ...rest
    });

    if (result && result.value && onSubmit) {
      return onSubmit(result);
    } else if (onCancel) {
      return onCancel();
    }

    return;
  };

  return { open };
};

export default useClassroomArchiveAlert;
